/* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react/jsx-props-no-spreading */
import * as React from 'react';
import axios from 'axios';
import {
  Table,
  TableBody,
  TableHead,
  TableRow,
  TableCell,
  Checkbox,
  Grid,
  Box,
  FormHelperText,
  IconButton,
  TableContainer,
  InputBase,
  Divider,
  FormControl,
  Input,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Button,
  Typography,
  FormControlLabel,
} from '@mui/material';
import PlayCircleFilledWhiteOutlinedIcon from '@mui/icons-material/PlayCircleFilledWhiteOutlined';
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd';
import TextField from '@mui/material/TextField';
import ReorderIcon from '@mui/icons-material/Reorder';
import {
  HouseHoldButton,
  MultiOpsIconButton,
  ToggleEditButton,
} from './HouseHold';
import { VisitStatus, Household, Gate } from '../../types';
import { reorder, range, addLeadingZeros } from '../territorycard/helpers';
import config from '../../config';
import { IconLabelButton } from './Buttons';
import { useLiveCard } from '../../services/liveCard';

interface GateViewProps extends Gate {
  handleGateEditToggle: (id: number) => () => void;
  isLock: boolean;
  handleHouseholdButtonClick: (x: number) => () => void;
  handleGateDelete: (id: number) => () => void;
  editable: boolean;
  handleHouseholdButtonLongClick?: (household: Household) => void;
}

export function GateView(props: GateViewProps) {
  // editable, here, is needed, because GateEditable is always rendered
  // with GateView
  const { id, name, households, buildingId, ...otherProps } = props;
  const {
    handleGateEditToggle,
    isLock,
    handleHouseholdButtonClick,
    handleGateDelete,
    editable,
    handleHouseholdButtonLongClick,
  } = otherProps;

  const householdWidth = editable ? '80%' : '90%';
  const nameView = name === '' ? '대문' : name;

  return (
    <Table aria-label="simple table">
      <TableBody>
        <TableRow hover>
          {/* <TableCell component="th" scope="row" padding="none">
            buildingName
          </TableCell> */}
          <TableCell component="th" scope="row" padding="none">
            {nameView}
          </TableCell>
          <TableCell
            align="left"
            padding="none"
            width={householdWidth}
            colSpan={2}
          >
            {households?.map((household: Household) => {
              return (
                <HouseHoldButton
                  key={household.id}
                  household={household}
                  onClick={handleHouseholdButtonClick}
                  onLongClick={handleHouseholdButtonLongClick}
                />
              );
            })}
          </TableCell>
          {editable ? (
            <TableCell component="th" scope="row" padding="none" width="10%">
              <ToggleEditButton
                visible={editable}
                id={1}
                isLock={isLock}
                onClick={() => handleGateEditToggle(id)}
              />
              <MultiOpsIconButton
                visible={editable}
                iconName="delete"
                onClick={handleGateDelete(id)}
              />
            </TableCell>
          ) : null}
        </TableRow>
      </TableBody>
    </Table>
  );
}

export function GateEditable(props: any) {
  const {
    isLock,
    gateName,
    households,
    handleGateNameChanged,
    handleHouseholdNameConfirmed,
    handleHouseholdEditToggle,
    handleHouseholdDelete,
    handleHouseholdAdd,
    handleHouseholdMultipleAdd,
    onDragEnd,
    onNoVisitStatusChanged,
    handleHouseholdNameChanged,
  } = props;

  const defaultHelper = 'hRange,wRange';

  const [expr, setExpr] = React.useState('');
  const [error, setError] = React.useState(false);
  const [errorMessage, setErrorMessage] = React.useState(defaultHelper);
  const [quadruple, setQuadruple] = React.useState(['0', '0', '0', '0']);

  const handleExprChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const expr = e.target.value;
    setExpr(expr);

    // validation
    let splits = expr.split(',');
    if (splits.length !== 2) {
      setError(true);
      setErrorMessage('use comma as delimiter');
      return;
    }
    const [hRange, wRange] = splits;
    splits = hRange.split('-');
    if (splits.length !== 2) {
      setError(true);
      setErrorMessage('hRange delimter is "-"');
      return;
    }
    const [hStart, hEnd] = splits;
    if (Number(hStart) > Number(hEnd)) {
      setError(true);
      setErrorMessage('hEnd is smaller than hStart');
      return;
    }
    splits = wRange.split('-');
    if (splits.length !== 2) {
      setError(true);
      setErrorMessage('wRange delimter is "-"');
      return;
    }
    const [wStart, wEnd] = splits;
    if (Number(hStart) > Number(hEnd)) {
      setError(true);
      setErrorMessage('wEnd is smaller than hStart');
      return;
    }

    setQuadruple([hStart, hEnd, wStart, wEnd]);
    setError(false);
    setErrorMessage(defaultHelper);
  };

  const handleExprExecuted = () => {
    if (!error) {
      handleHouseholdMultipleAdd(quadruple);
      setExpr('');
    }
  };
  // Normally you would want to split things out into separate components.
  // But in this example everything is just done in one place for simplicity
  return (
    <TableContainer
      sx={{
        height: 200,
        border: 1,
        m: 1,
      }}
    >
      <Grid container spacing={1} sx={{ p: 1 }}>
        <Grid item xs={6}>
          <Box
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
            }}
          >
            <InputBase
              sx={{ flex: 1 }}
              placeholder="입구 이름 혹은 층수 정보"
              defaultValue={gateName}
              size="small"
              disabled={isLock}
              onChange={handleGateNameChanged}
            />
          </Box>
        </Grid>
        <Grid item xs={6}>
          <Box
            sx={{
              p: '2px 4px',
              display: 'flex',
              alignItems: 'center',
              backgroundColor: '#eeeeee',
            }}
          >
            <FormControl error={error} variant="standard">
              {/* <InputLabel htmlFor="component-error">Name</InputLabel> */}
              <Input
                id="component-error"
                placeholder="특수식: 1-15, 1-2"
                value={expr}
                onChange={handleExprChanged}
                aria-describedby="component-error-text"
              />
              <FormHelperText id="component-error-text">
                {errorMessage}
              </FormHelperText>
            </FormControl>
            <Divider sx={{ height: 28, m: 1 }} orientation="vertical" />
            <IconButton
              sx={{ p: '1px' }}
              aria-label="search"
              onClick={handleExprExecuted}
            >
              <PlayCircleFilledWhiteOutlinedIcon />
            </IconButton>
          </Box>
          {/* </Box> */}
        </Grid>
      </Grid>
      <DragDropContext onDragEnd={onDragEnd}>
        <Droppable droppableId="droppable" direction="vertical">
          {(provided, snapshot) => (
            <>
              <Table
                aria-label="simple table"
                ref={provided.innerRef}
                sx={{
                  height: 'max-content',
                }}
                stickyHeader
              >
                <TableHead>
                  <TableRow>
                    <TableCell padding="none">이동</TableCell>
                    <TableCell padding="none">세대이름</TableCell>
                    <TableCell padding="none">방문금지</TableCell>
                    <TableCell padding="none">작업</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {households.map((item: Household, index: number) => (
                    <Draggable
                      key={item.id}
                      draggableId={item.id.toString()}
                      index={index}
                    >
                      {(provided, snapshot) => (
                        <TableRow
                          ref={provided.innerRef}
                          {...provided.draggableProps}
                          {...provided.dragHandleProps}
                        >
                          <TableCell align="left" padding="normal">
                            <div {...provided.dragHandleProps}>
                              <ReorderIcon />
                            </div>
                          </TableCell>
                          <TableCell
                            sx={{ whiteSpace: 'nowrap' }}
                            padding="none"
                          >
                            <TextField
                              disabled={item.isLock}
                              defaultValue={item.name}
                              variant="standard"
                              size="small"
                              margin="none"
                              onChange={handleHouseholdNameChanged(item.id)}
                              onKeyDown={handleHouseholdNameConfirmed(item.id)}
                            />
                          </TableCell>
                          <TableCell
                            sx={{ whiteSpace: 'nowrap' }}
                            padding="none"
                          >
                            <Checkbox
                              id={item.id.toString()}
                              disabled={item.isLock}
                              checked={item.status === VisitStatus.noVisit}
                              onChange={onNoVisitStatusChanged(item.id)}
                              sx={{ p: 0 }}
                            />
                          </TableCell>
                          <TableCell padding="none">
                            <MultiOpsIconButton
                              visible
                              iconName="delete"
                              onClick={handleHouseholdDelete(item.id)}
                            />
                            {/* <ToggleEditButton
                              visible
                              id={item.id}
                              isLock={item.isLock}
                              onClick={handleHouseholdEditToggle}
                            /> */}
                          </TableCell>
                        </TableRow>
                      )}
                    </Draggable>
                  ))}
                  {provided.placeholder}
                </TableBody>
              </Table>
              <IconLabelButton
                visible
                align="left"
                iconName="add"
                label="세대추가"
                onClick={handleHouseholdAdd}
              />
            </>
          )}
        </Droppable>
      </DragDropContext>
    </TableContainer>
  );
}

interface GateComponentProps {
  gate: Gate;
  handleGateUpdate: (id: number, name: string) => Promise<void>;
  handleGateDelete: (id: number) => () => void;
  editable: boolean;
  buildingLock: boolean;
}

export function GateComponent(props: GateComponentProps) {
  const { gate, handleGateUpdate, handleGateDelete, editable, buildingLock } =
    props;

  const live = useLiveCard();
  const [isLock, setIsLock] = React.useState(true);
  const [householdList, setHouseholdList] = React.useState(
    gate.households as Household[],
  );
  const [buildingName, setBuildingName] = React.useState('');
  const [gateName, setGateName] = React.useState(gate.name);
  const [openEditor, setOpenEditor] = React.useState(false);
  const [selected, setSelected] = React.useState<Household>({} as Household);

  const handleGateEditToggle = () => () => {
    setIsLock(!isLock);
  };

  React.useEffect(() => {
    if (buildingLock) {
      setIsLock(buildingLock);
    }
  }, [buildingLock]);

  const handleHouseholdDelete = (id: number) => async () => {
    try {
      await axios.delete(`${config.api.url}/mdsouth/households/${id}`);
      setHouseholdList(
        householdList.filter((household: Household) => {
          return household.id !== id;
        }),
      );
    } catch (error) {
      console.log(error);
    }
  };

  const handleHouseholdAdd = async () => {
    try {
      const { data } = await axios.post(
        `${config.api.url}/mdsouth/households`,
        {
          name: '',
          status: VisitStatus.intact,
          gateId: gate.id,
        },
      );
      setHouseholdList([
        ...householdList,
        {
          id: data.id,
          name: '',
          status: VisitStatus.intact,
          isLock: false,
          gateId: gate.id,
        },
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  const handleHouseholdMultipleAdd = async ([
    hStart,
    hEnd,
    wStart,
    wEnd,
  ]: string[]) => {
    const newHouseholds: Household[] = [];
    let count = 0;
    range(Number(hStart), Number(hEnd) + 1).forEach(h => {
      range(Number(wStart), Number(wEnd) + 1).forEach(w => {
        newHouseholds.push({
          id: householdList.length + count,
          name: String(h) + addLeadingZeros(w, 2),
          status: VisitStatus.intact,
          isLock: false,
          gateId: gate.id,
        });
        count += 1;
      });
    });
    try {
      const resList = await Promise.all(
        newHouseholds.map((household: Household) =>
          axios.post(`${config.api.url}/mdsouth/households`, {
            name: household.name,
            status: VisitStatus.intact,
            gateId: gate.id,
          }),
        ),
      );

      setHouseholdList([
        ...householdList,
        ...resList.map(({ data }, index) => {
          newHouseholds[index].id = data.id;
          return newHouseholds[index];
        }),
      ]);
    } catch (error) {
      console.log(error);
    }
  };

  const onDragEnd = async (result: any) => {
    // dropped outside the list
    if (!result.destination) {
      return;
    }

    const reOrderedHouseholdList = reorder(
      householdList,
      result.source.index,
      result.destination.index,
    );
    try {
      // rewrite
      await Promise.all(
        householdList.map((household: Household, index: number) =>
          axios.put(`${config.api.url}/mdsouth/households/${household.id}`, {
            name: reOrderedHouseholdList[index].name,
            status: reOrderedHouseholdList[index].status,
            gateId: gate.id,
          }),
        ),
      );

      setHouseholdList(reOrderedHouseholdList);
    } catch (error) {
      console.log(error);
    }
  };

  const onNoVisitStatusChanged = (id: number) => async () => {
    try {
      const tmpHouseholds = householdList.map((household: Household) => {
        if (household.id === id) {
          return {
            ...household,
            status:
              household.status === VisitStatus.noVisit
                ? VisitStatus.intact
                : VisitStatus.noVisit,
          };
        }
        return household;
      });

      const updatedHousehold = tmpHouseholds.find(i => i.id === id);
      await axios.put(`${config.api.url}/mdsouth/households/${id}`, {
        // name: updatedHousehold?.name,
        status: updatedHousehold?.status,
        gateId: gate.id,
      });
      setHouseholdList(tmpHouseholds);
    } catch (error) {
      console.log(error);
    }
  };

  function updateVisitStatus(household: Household): Household {
    if (household.status === VisitStatus.noVisit) {
      return household;
    }
    return {
      ...household,
      status:
        household.status === VisitStatus.met
          ? VisitStatus.intact
          : household.status + 1,
    };
  }

  const handleHouseholdButtonClick = (id: number) => async () => {
    const current = householdList.find(
      (household: Household) => household.id === id,
    );
    // noVisit households don't cycle on tap (unchanged behaviour).
    if (!current || current.status === VisitStatus.noVisit) return;

    // Announce presence (so co-viewers see the editing ring) then toggle with
    // optimistic concurrency; live.toggle handles the PUT, the card broadcast,
    // and 409 conflict reconciliation.
    live.reportEditing(id);
    try {
      const { status } = await live.toggle(id, current.status);
      setHouseholdList(
        householdList.map((household: Household) =>
          household.id === id ? { ...household, status } : household,
        ),
      );
    } catch (error) {
      console.log(error);
    } finally {
      live.reportEditing(null);
    }
  };

  const handleHouseholdNameChanged =
    (id: number) => async (e: React.ChangeEvent<HTMLInputElement>) => {
      const text = e.target.value;

      let updatedHousehold = {} as Household;
      const tmpHouseholdList = householdList.map((household: Household) => {
        if (household.id === id) {
          updatedHousehold = {
            ...household,
            name: text,
          };
          return updatedHousehold;
        }
        return household;
      });

      try {
        await axios.put(`${config.api.url}/mdsouth/households/${id}`, {
          name: updatedHousehold?.name,
          status: updatedHousehold?.status,
          gateId: gate.id,
        });
      } catch (error) {
        console.log(error);
      }

      setHouseholdList(tmpHouseholdList);
    };

  const updateHousehold = async (
    id: number,
    name: string,
    noVisit: boolean,
  ) => {
    let updatedHousehold = {} as Household;
    const tmpHouseholdList = householdList.map((household: Household) => {
      if (household.id === id) {
        updatedHousehold = {
          ...household,
          name,
          status: noVisit ? VisitStatus.noVisit : VisitStatus.intact,
        };
        return updatedHousehold;
      }
      return household;
    });

    try {
      await axios.put(`${config.api.url}/mdsouth/households/${id}`, {
        name: updatedHousehold?.name,
        status: updatedHousehold?.status,
        gateId: gate.id,
      });
    } catch (error) {
      console.log(error);
    }

    setHouseholdList(tmpHouseholdList);
  };

  const handleHouseholdNameConfirmed =
    (id: number) => (e: React.KeyboardEvent<HTMLInputElement>) => {
      if (e.key === 'Enter') {
        // if enter pressed at the last elem, add one
        const index = householdList.findIndex(i => i.id === id);
        if (index === householdList.length - 1) {
          handleHouseholdAdd();
        }
      }
    };

  const handleGateNameChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setGateName(text);
    handleGateUpdate(gate.id, text);
  };

  const handleHouseholdButtonLongClick = (household: Household) => {
    setSelected(household);
    setOpenEditor(true);
  };

  const handleHouseHoldEditDialogClose =
    (answer: string, name?: string, noVisit?: boolean) => async () => {
      switch (answer) {
        case 'update':
          await updateHousehold(
            selected.id,
            name as string,
            noVisit as boolean,
          );
          break;
        default:
          break;
      }
      setOpenEditor(false);
    };

  return (
    <>
      {/* <Grid item xs={12} {...others}>
        <Paper sx={{ p: 2, display: 'flex', flexDirection: 'column' }}> */}
      <GateView
        id={gate.id}
        name={gateName}
        households={householdList}
        buildingId={gate.buildingId}
        handleGateEditToggle={handleGateEditToggle}
        isLock={isLock}
        handleHouseholdButtonClick={handleHouseholdButtonClick}
        handleGateDelete={handleGateDelete}
        editable={editable}
        handleHouseholdButtonLongClick={handleHouseholdButtonLongClick}
      />
      <HouseHoldEditDialog
        open={openEditor}
        title="세대 정보 수정"
        message="세대 정보를 수정합니다. 변경하고 싶은 내용을 넣어주세요"
        selected={selected}
        handleClose={handleHouseHoldEditDialogClose}
      />
      {isLock ? (
        <> </>
      ) : (
        <GateEditable
          isLock={isLock}
          gateName={gateName}
          households={householdList}
          handleGateNameChanged={handleGateNameChanged}
          handleHouseholdNameConfirmed={handleHouseholdNameConfirmed}
          // handleHouseholdEditToggle={handleHouseholdEditToggle}
          handleHouseholdDelete={handleHouseholdDelete}
          handleHouseholdAdd={handleHouseholdAdd}
          handleHouseholdMultipleAdd={handleHouseholdMultipleAdd}
          onDragEnd={onDragEnd}
          onNoVisitStatusChanged={onNoVisitStatusChanged}
          handleHouseholdNameChanged={handleHouseholdNameChanged}
        />
      )}
    </>
  );
}

interface HouseHoldEditDialogProps {
  open: boolean;
  title: string;
  message: string;
  selected: Household;
  handleClose: (answer: string, name?: string, noVisit?: boolean) => () => void;
}

export function HouseHoldEditDialog({
  open,
  title,
  message,
  selected,
  handleClose,
}: HouseHoldEditDialogProps) {
  const [name, setName] = React.useState('');
  const [noVisit, setNoVisit] = React.useState(false);

  const handleTextChanged = (e: React.ChangeEvent<HTMLInputElement>) => {
    const text = e.target.value;
    setName(text);
  };

  const onNoVisitStatusChanged = () => {
    setNoVisit(!noVisit);
  };

  React.useEffect(() => {
    setName(selected.name);
    setNoVisit(selected.status === VisitStatus.noVisit);
  }, [selected]);

  return (
    <Dialog
      open={open}
      onClose={handleClose('close')}
      aria-labelledby="edit-dialog-title"
      aria-describedby="edit-dialog-description"
    >
      <DialogTitle id="edit-dialog-title">{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id="edit-dialog-description">
          {message}
        </DialogContentText>
        <DialogContentText>기존 이름: {selected.name}</DialogContentText>
        <TextField
          autoFocus
          margin="dense"
          id="name"
          label="변경할 이름"
          type="name"
          fullWidth
          variant="standard"
          value={name}
          onChange={handleTextChanged}
        />
        <FormControlLabel
          sx={{ mt: 1, ml: 0 }}
          control={
            <Checkbox
              checked={noVisit}
              onChange={onNoVisitStatusChanged}
              sx={{ p: 0 }}
            />
          }
          label="방문 금지 설정"
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose('update', name, noVisit)}>수정 </Button>
        <Button onClick={handleClose('cancel')}>취소</Button>
      </DialogActions>
    </Dialog>
  );
}
